import React from 'react';
import { AppState } from 'models/app-store';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import TimeFieldSimple from 'react-simple-timefield';
import classes from './DatePickerFooter.module.scss';

type Props = {
  time?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const DatePickerFooterView = (props: React.PropsWithChildren<Props>): JSX.Element => {
  const { t } = useTranslation();

  const darkMode = useSelector((state: AppState) => state.ui.darkMode);

  const customStyle: React.CSSProperties = {
    color: 'rgba(255, 255, 255, 0.87)',
    height: '30px',
    width: '50px',
    borderRadius: '8px',
    border: '1px solid #e3e7ea',
    textAlign: 'center',
    outline: 'none',
    backgroundColor: 'transparent',
    ...(!darkMode && {
      color: '#5c6873',
      outline: 'none',
    }),
  };

  return (
    <div className={classes['container']}>
      <div>
        <p className={classes['title']}>{t('common.hour')}</p>
        <TimeFieldSimple
          style={customStyle}
          value={props.time}
          onChange={(event) => {
            event.preventDefault();
            event.stopPropagation();

            props.onChange(event);
          }}
        ></TimeFieldSimple>
      </div>
    </div>
  );
};

DatePickerFooterView.displayName = 'DatePickerFooterView';

export default DatePickerFooterView;
